import React, { createContext, useContext, useState, useEffect } from "react";

// Upload Context 創建
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [AuthData, setAuthData] = useState({
    accessToken: "",
    // description: "",
    // client: "",
    // project: "",
    // keywords: [],
    // files: [],
  });
  const [user, setUser] = useState(null);


  //   const [uploadStatus, setUploadStatus] = useState(""); // 用於管理上傳狀態

  // 提供更新函數，支持局部更新
  const updateAuthData = (field, value) => {
    setAuthData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  useEffect(() => {
    const tokenFromStorage = sessionStorage.getItem("flaskAccessToken");
    if (tokenFromStorage) {
      setAuthData(prev => ({ ...prev, flaskAccessToken: tokenFromStorage }));
    }
  }, []);

  // useEffect(() => { console.log("AuthProvider user:", user) }, [user])

  return (
    <AuthContext.Provider value={{
      AuthData,
      setAuthData,
      updateAuthData,
      user, setUser
      // updateUploadData,
      // uploadStatus, // 確保上傳狀態被傳入
      // setUploadStatus, // 確保更新狀態的函數被傳入
    }}>
      {children}
    </AuthContext.Provider>
  );
};

// 自定義 Hook
export const useAuthContext = () => useContext(AuthContext);
